import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import Icons from '../../Elements/Icons';
const IconSlot = styled.div `
  margin-left: auto;
`;
const ItemWrapper = styled.div `
  ${({ theme }) => theme.typography.textMedium}
  ${({ theme }) => theme.typography.weightMedium}
  display: flex;
  gap: 6px;
  align-items: center;
  width: 100%;
  padding: 12px 12px;
  height: 44px;
  background: ${({ active, theme }) => (active ? theme.colors.grey01_1 : theme.colors.grey00_6)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${({ active, disabled, theme }) => {
    if (active)
        return theme.colors.black_1;
    if (disabled)
        return theme.colors.grey30_1;
    return theme.colors.grey100_1;
}};
  counter-increment: section;
  &:hover {
    background: ${({ disabled, theme }) => !disabled && theme.colors.grey05_1};
  }
  ::before {
    ${({ theme }) => theme.typography.textMedium}
    ${({ theme }) => theme.typography.weightMedium}
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme, disabled, active }) => (disabled && !active ? theme.colors.grey70_3 : theme.colors.grey00_2)};
    border-radius: 50%;
    flex-shrink: 0;
    background: ${({ active, disabled, theme }) => {
    if (active)
        return theme.colors.main;
    if (disabled)
        return theme.colors.grey01_2;
    return theme.colors.grey70_1;
}};
    content: counter(section);
  }
`;
export const VerticalNavigationGroupItem = forwardRef(function VerticalNavigationGroupItem(props, ref) {
    const { children, error } = props;
    const theme = useTheme();
    return (_jsxs(ItemWrapper, { ref: ref, ...props, children: [children, error && (_jsx(IconSlot, { children: _jsx(Icons.Warning, { filled: true, color: theme.colors.critical100 }) }))] }));
});
export const VerticalNavigationGroupWrapper = styled.div `
  ${({ theme }) => theme.shadows.medium}
  border-radius: 8px;
  width: 100%;
  background: ${({ theme }) => theme.colors.grey00_6};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 0px;
`;
export const VerticalNavigationGroup = ({ items, onChange, initialId, activeId }) => {
    const [currentItem, setCurrentItem] = useState(initialId || 0);
    const createClickHandler = useCallbackRef((id) => () => {
        setCurrentItem(id);
        onChange(id);
    });
    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        if (activeId)
            setCurrentItem(activeId);
    }, [activeId]);
    return (_jsx(VerticalNavigationGroupWrapper, { children: items
            .filter((item) => !item.hidden)
            .map(({ title, id, disabled, error }, index) => (_jsx(VerticalNavigationGroupItem, { onClick: createClickHandler(id || index), disabled: disabled, error: error, active: id ? currentItem === id : currentItem === index, children: title }, id || index))) }));
};
